export const SET_BUSINESSES = 'SET_BUSINESSES';
export const SET_BUSINESSES_LOADING = 'SET_BUSINESSES_LOADING';
